<template>
  <v-flex xs12>
    <v-card class="campaign analytics card">
      <v-card-title>
        <v-icon left>mdi-clock-start</v-icon>
        <router-link style="color: rgba(0, 0, 0, 0.87)"
          :to="`/client/analytics/explorer?source=${campaign.slug}`">
          {{ campaign.slug | uppercase }}
        </router-link>
      </v-card-title>
      <v-divider />
      <v-card-text v-if="signups.loading || applications.loading || funnel.loading" class="text-xs-center">
        <em>Loading…</em>
      </v-card-text>
      <v-card-text v-else-if="Object.keys(signups).length === 0">
        <div class="information caption">
          <v-icon small color="grey">mdi-clock</v-icon>
          {{ new Date(campaign.createdAt) | date('d MMMM yyy') }}
        </div>
        <div class="information caption">
          <v-icon small color="grey">
            {{ campaign.campaignable.type == 'Opportunity' ? 'mdi-briefcase' : 'mdi-domain' }}
          </v-icon>
          {{ campaign.campaignable.name }}
        </div>
        <div class="text-xs-center">
          <em>No signups from this campaign yet.</em>
        </div>
      </v-card-text>
      <v-card-text v-else>
        <div class="information caption">
          <v-icon small color="grey">mdi-clock</v-icon>
          {{ new Date(campaign.createdAt) | date('d MMMM yyy') }}
        </div>
        <div class="information caption">
          <v-icon small color="grey">
            {{ campaign.campaignable.type == 'Opportunity' ? 'mdi-briefcase' : 'mdi-domain' }}
          </v-icon>
          {{ campaign.campaignable.name }}
        </div>
        <apex v-if="!signups.loading && !applications.loading"
          type="line"
          width="100%"
          height="400px"
          :options="{
            colors,
            stroke: { show: true, width: 2 },
            chart: { fontFamily: 'Heebo, sans-serif', toolbar: { show: true }, /*zoom: { enabled: false }*/ },
            xaxis: { type: 'datetime' },
            yaxis: { min: 0, decimalsInFloat: false },
            dataLabels: { enabled: false },
            /* tooltip: { enabled: false }, */
            labels,
          }"
          :series="series"
        />
        <apex v-if="!funnel.loading"
          type="bar"
          width="100%"
          :height="linearChartSize(Object.keys(funnel).length)"
          :options="{
            labels: [campaign.slug],
            colors,
            chart: { fontFamily: 'Heebo, sans-serif', toolbar: { show: true } },
            plotOptions: {
              bar: {
                horizontal: true,
                dataLabels: { position: 'top' },
              },
            },
            tooltip: { followCursor: true },
            yaxis: { show: false },
          }"
          :series="Object.keys(funnel).map(name => ({ name, data: [funnel[name]]}))"
        />
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
// Data
import colors from '@/data/colors'

// Vue Component
export default {
  props: {
    campaign: { type: Object },
  },
  created() {
    Vue.$http.get(`client/campaigns/${this.campaign.slug}/analytics/funnel`).then(({ data }) => (this.funnel = data))
    Vue.$http.get(`client/campaigns/${this.campaign.slug}/analytics/signups`).then(({ data }) => (this.signups = data))
    Vue.$http.get(`client/campaigns/${this.campaign.slug}/analytics/applications`).then(({ data }) => (this.applications = data))
  },
  data() {
    return {
      colors: colors.analytics,
      signups: { loading: true },
      applications: { loading: true },
      funnel: { loading: true },
    }
  },
  computed: {
    labels() {
      if (!this.signups.loading && !this.applications.loading) {
        return _.sortBy(_.uniq(Object.keys(this.signups).concat(Object.keys(this.applications))))
      } else {
        return []
      }
    },
    signupSeries() {
      return this.labels.map(date => (this.signups[date] || 0))
    },
    applicationsSeries() {
      return this.labels.map(date => (this.applications[date] || 0))
    },
    series() {
      if (!this.signups.loading && !this.applications.loading) {
        return [
          { name: 'Signups', data: this.signupSeries },
          { name: 'Applications', data: this.applicationsSeries },
        ]
      } else {
        return []
      }
    },
  },
  methods: {
    linearChartSize(count) {
      return 100 + count * 20
    },
  },
}
</script>

<style lang="scss">
.campaign.analytics.card {
  .information.caption {
    .v-icon {
      padding-bottom: 2px;
    }
  }
}
</style>
